import Swiper from 'swiper';

import domReady from '@wordpress/dom-ready';

domReady(() => {
  const breakpoint = window.matchMedia('(min-width: 768px)');
  let logosSwiper;

  const breakpointChecker = () => {
    if (breakpoint.matches) {
      if (logosSwiper) logosSwiper.destroy(true, true);

      document
        .querySelectorAll(
          '.logos_grid_swiper .acf-innerblocks-container .logos-grid-item'
        )
        .forEach((el) => el.classList.remove('swiper-slide'));

      const wrapper = document.querySelector(
        '.logos_grid_swiper .acf-innerblocks-container'
      );
      if (wrapper) wrapper.classList.remove('swiper-wrapper');

      const pagination = document.querySelector(
        '.logos_grid_swiper .vtx-swiper__pagination'
      );
      if (pagination) pagination.style.display = 'none';
    } else {
      document
        .querySelectorAll(
          '.logos_grid_swiper .acf-innerblocks-container .logos-grid-item'
        )
        .forEach((el) => el.classList.add('swiper-slide'));

      const wrapper = document.querySelector(
        '.logos_grid_swiper .acf-innerblocks-container'
      );
      if (wrapper) wrapper.classList.add('swiper-wrapper');

      const pagination = document.querySelector(
        '.logos_grid_swiper .vtx-swiper__pagination'
      );
      if (pagination) pagination.style.display = 'block';

      enableSwiper();
    }
  };

  const enableSwiper = () => {
    const carousel = document.querySelector('.logos_grid_swiper');
    if (!carousel) return;

    logosSwiper = new Swiper(carousel, {
      slidesPerView: 1,
      spaceBetween: 20,
      preloadImages: false,
      lazy: true,
      pagination: {
        el: '.logos_grid_swiper .vtx-swiper__pagination',
        type: 'bullets',
        clickable: true,
        hiddenClass: 'swiper-pagination-hidden',
      },
      navigation: {
        nextEl: '.logos_grid_swiper .swiper-button-next',
        prevEl: '.logos_grid_swiper .swiper-button-prev',
      },
      observeParents: true,
      observer: true,
    });
  };

  breakpointChecker();
  window.addEventListener('resize', breakpointChecker);
});
